import { Controller } from 'stimulus';
import Swiper, { Pagination, EffectFade, Navigation, Controller as SwiperController } from 'swiper';

class FeaturedCarousel extends Controller {

  connect() {
    // Featured carousel
    Swiper.use([Pagination, EffectFade, Navigation, SwiperController]);
    
    const carousels = document.querySelectorAll('.swiper-featured-carousel');

    /**
     * Adds a unique class to the element and returns the new class name 
     * 
     * @param {String} className 
     * @param {Int} uniqueId 
     * @returns String unique classname
     */
    const uniqueEls = (className, containerEl, uniqueId) => {
      if (containerEl.querySelector(`.${className}`)) containerEl.querySelector(`.${className}`).classList.add(`${className}__${uniqueId}`);
      return `.${className}__${uniqueId}`;
    }

    carousels.forEach((carousel, i) => {
      const featured = carousel;
      if (featured.dataset.initialized) return;
      else featured.dataset.initialized = true;

      featured.classList.add(`swiper-featured-carousel__${i}`);
      const featuredContainer = featured.parentNode.parentNode;
      const sliderFunction = (settings = {}) => {
        const genSettings = {
          autoHeight: true,
          grabCursor: true,
          loop: false,
          loopFillGroupWithBlank: true,
          watchOverflow: true,
          navigation: {
            nextEl: uniqueEls('swiper-featured-carousel-button--next', featuredContainer, i),
            prevEl: uniqueEls('swiper-featured-carousel-button--prev', featuredContainer, i),
          },
          slideVisibleClass: 'featured-carousel-visible',
          slidePrevClass: 'featured-carousel-prev',
          slideNextClass: 'featured-carousel-next',
        };
        settings = {
          autoplay: {
            delay: 5000,
          },
          breakpoints: {
            1280: {
              autoHeight: false,
            },
          },
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: uniqueEls('swiper-featured-carousel-pagination', featuredContainer, i),
            bulletClass: 'swiper-pagination-bullet swiper-pagination-bullet-secondary',
            bulletActiveClass: 'swiper-pagination-bullet-active swiper-pagination-bullet-active-secondary',
            clickable: true,
          },
          on: {
            init: function (swiper) {
              if(swiper.slides.length <= 1) {
                $(`.swiper-featured-carousel-button--next__${i}`).hide();
                $(`.swiper-featured-carousel-button--prev__${i}`).hide();
              }
            },
          },
          ...genSettings
        };
        return settings;
      }
      const featured_slider = new Swiper(`.swiper-featured-carousel__${i}`, sliderFunction()); 
      featured_slider.controller.control = featured_slider;
    });
  }
}

FeaturedCarousel.targets = ['slider'];

export default FeaturedCarousel;